import { ProductProcessorsCollection } from "../processor/ProductProcessorsCollection.mjs";
import { ProductProcessorsEnum } from "../processor/ProductProcessorsEnum.mjs";
import { ProductItem } from "../ProductItem.mjs";
import { ProductAttrComputer } from "../ProductAttrComputer.mjs";
import { ProductAttrConditionEvaluator } from "../ProductAttrConditionEvaluator.mjs";
import { CherryPickHelper } from "../CherryPickHelper.mjs";
import { AttributeValueParserProcessor } from "../processor/processors/AttributeValueParserProcessor.mjs";
export class ProductContext {
    constructor() {
        this.processors = new ProductProcessorsCollection();
        this.sku = '';
        this.productItem = new ProductItem('', '');
        this.attrEvaluator = new ProductAttrConditionEvaluator();
        this.attrComputer = new ProductAttrComputer(this.attrEvaluator);
        this.cherryPicks = new CherryPickHelper(this.attrComputer, {});
        this.processors.registerProcessor(ProductProcessorsEnum.ATTR_VALUE_PARSER, new AttributeValueParserProcessor(this.cherryPicks));
    }
    reset(productItem, attributesMap, keepCherryPicks = false) {
        this.productItem.reset(productItem);
        this.attrComputer.reset(attributesMap);
        this.attrEvaluator.reset(attributesMap);
        if (!keepCherryPicks) {
            this.cherryPicks.reset();
        }
        this.sku = productItem.sku;
    }
    getSKU() {
        return this.sku;
    }
    invokeProcessors() {
        console.groupCollapsed('ProductContext::invokeProcessors()');
        console.log('Before processors:', JSON.parse(JSON.stringify(this.productItem.getAttributes())));
        this.processors.invokeProcessors(this.productItem, this.attrComputer);
        console.log('After processors:', JSON.parse(JSON.stringify(this.productItem.getAttributes())));
        console.groupEnd();
    }
    setCherryPicks(attributes, setAlsoAsPreferred = false) {
        this.cherryPicks.setAttributes(attributes);
        if (setAlsoAsPreferred) {
            /**
             * A part from setting cherry picks this will also tell the ProductAttrComputer to include
             * the attribute values you desire in the filters (if those values are not constrained).
             *
             * This will help when QT creates orders with material / laminate combinations that aren't visible to the customers (filtered out)
             * and prevent editor to reset the material / laminate combination to only what's visible to customer.
             */
            this.attrComputer.setPreferredValues(JSON.parse(JSON.stringify(attributes)));
        }
    }
}
